var React = require('react');

function ArrowRightBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.000224181 0L3.14954 0L6.81104 7.49834L3.14954 15H0.000224181L3.66172 7.49834L0.000224181 0Z","fill":"#3287C8"}));
}

ArrowRightBlue.defaultProps = {"width":"7","height":"15","viewBox":"0 0 7 15","fill":"none"};

module.exports = ArrowRightBlue;

ArrowRightBlue.default = ArrowRightBlue;
